import {createSlice} from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  has_prev: false,
  has_next: false,
  total_pages: 0,
  total_results: 0,
  error: "",
  data: [],
  page: 0,

}

const wishlistSlice = createSlice({
  name: 'wishlistSlice',
  initialState: initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload
      state.error = ''
    },

    setWishlist: (state, action) => {
      return {
        ...state, loading: false,
        has_next: action.payload.has_next,
        has_prev: action.payload.has_prev,
        total_pages: action.payload.total_pages,
        total_results: action.payload.total_results,
        page: action.payload.page,
        data: action.payload.data,
        error: ''
      };
    },

    getWishlist: (state, action) => {
    },

    setError: (state, action) => {
      state.error = action.payload
      state.loading = false
    },
    setPage:(state, action) => {
      state.page = action.payload;
    }
  }

})

export const {
  setLoading,
  setError,
  setWishlist,
  getWishlist,
  setPage
} = wishlistSlice.actions;
export default wishlistSlice.reducer;
